import { OPEN_MENU, CLOSE_MENU, GO_HOME, GONE_HOME } from "../actions/menu";

const menuInitialState = {
  menuOpen: false,
  goHome: false,
};

const menuReducer = (state = menuInitialState, action) => {
  switch (action.type) {
    case "LOGOUT_STORE":
    case "RESET_STORE":
      return {
        ...menuInitialState,
      };
    case OPEN_MENU:
      return {
        ...state,
        menuOpen: true,
      };
    case CLOSE_MENU:
      return {
        ...state,
        menuOpen: false,
      };
    case GO_HOME:
      return {
        ...state,
        goHome: true,
      };
    case GONE_HOME:
      return {
        menuOpen: false,
        goHome: false,
      };

    default:
      return state;
  }
};

export default menuReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/menu.js